import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../../client';

export type RequestSubmissionInput =
  | {
    formId: string;
    email: string;
  } | {
    formId: string;
    userId: string;
  };

export type RequestSubmissionOutput = {
  status: string;
  message: string;
};

export const requestSubmission = (data: RequestSubmissionInput) =>
  restClient.request<RequestSubmissionOutput>('/api/v1/form/request_submission', {
    method: 'POST',
    data: snakecaseKeys(data)
  });


export type RequestAdministeredSubmissionParams = {
  patientId: string;
  formId: string;
};
export const requestAdministeredSubmission = (params: RequestAdministeredSubmissionParams) => restClient.request<{
  data: {
    status: 'created' | 'existing';
    submissionId: string;
  };
}>('/api/v1/form/request_administered_submission', {
  method: 'POST',
  data: snakecaseKeys(params)
});
